import { Link } from 'react-router-dom';

export default function SafetySection() {
  const checklists = [
    {
      risk: 'Fake Websites',
      solution: 'Always verify you are using the official VigorBuy Spreadsheet source to avoid phishing sites and scams.',
    },
    {
      risk: 'Wrong Products',
      solution: 'Review QC photos carefully before purchasing. Cross-check product codes and descriptions against the spreadsheet.',
    },
    {
      risk: 'Payment Risks',
      solution: 'Use secure payment methods with buyer protection. Never share payment details outside of trusted platforms.',
    },
    {
      risk: 'Privacy Risks',
      solution: 'Protect your personal data. Use strong passwords and avoid sharing account credentials with third parties.',
    },
  ];

  return (
    <section id="safety" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            Safety First
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
            Is <strong className="font-heading font-normal text-primary-600">VigorBuy Spreadsheet</strong> Safe?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Your security matters. Here is what you need to know to shop safely and confidently
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto mb-10">
          {checklists.map((item) => (
            <div
              key={item.risk}
              className="flex gap-4 p-5 md:p-6 bg-white rounded-xl border border-background-200/70 hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-shield-check-line text-lg md:text-xl text-accent-600"></i>
              </div>
              <div>
                <h4 className="font-heading text-sm md:text-base text-foreground-900 mb-1.5">{item.risk}</h4>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.solution}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium text-sm rounded-full hover:bg-primary-600 transition-all cursor-pointer"
          >
            Read Complete Safety Guide <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}